import { render, staticRenderFns } from "./FilmActiveData.vue?vue&type=template&id=0b335a6f&scoped=true"
import script from "./FilmActiveData.vue?vue&type=script&lang=ts"
export * from "./FilmActiveData.vue?vue&type=script&lang=ts"
import style0 from "./FilmActiveData.vue?vue&type=style&index=0&id=0b335a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b335a6f",
  null
  
)

export default component.exports